import React, { useEffect, useState } from "react";
import {
    Dialog,
    useMediaQuery,
    useTheme,
    Typography,
    Box,
    Divider,
    Tabs,
    Tab,
    Paper,
    Grid 
} from "@mui/material";
import { IoCloseCircleOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { getAllTransactionsById, openshowTransactionDialog } from "../Redux/Dashboard/DashboardSlice";
import Spinner from "../Spinner/Spinner";

const TransactionsDetailsDialog = () => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const dispatch = useDispatch();
    const loader = useSelector((s) => s.DashboardSlice.loader);
    const selectedTransaction = useSelector((s) => s.DashboardSlice.selectedTransaction);
    const getTransactionsById = useSelector((s) => s.DashboardSlice.getTransactionsById);

    const open = useSelector((s) => s.DashboardSlice.openshowTransactionDialog);
    const [tabIndex, setTabIndex] = useState(0); // 0 = Course, 1 = User

    useEffect(() => {
        dispatch(getAllTransactionsById({ id: selectedTransaction }))
    }, [selectedTransaction, dispatch]);

    const handleClose = () => {
        dispatch(openshowTransactionDialog(false));
        setTabIndex(0);
    };

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    p: 3,
                    bgcolor: "#fafafa",
                },
            }}
        >
            <Box>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h5" fontWeight="bold">
                        Transaction Details
                    </Typography>
                    <IoCloseCircleOutline
                        size={28}
                        onClick={handleClose}
                        style={{ cursor: "pointer", color: "#f44336" }}
                    />
                </Box>

                <Tabs value={tabIndex} onChange={(e, newVal) => setTabIndex(newVal)} centered sx={{ mb: 3 }}>
                    <Tab label="🙍‍♂️ User Details" />
                    <Tab label=" 📚 Course Details" />
                </Tabs>

                <Divider sx={{ mb: 2 }} />

                {loader ? (
                    <Spinner />
                ) : (
                    <>
                        {/* User Details */}
                        {tabIndex === 0 && (
                            <Box>                        
                            <Paper elevation={4} sx={{
                                p: 4,
                                borderRadius: 4,
                                background: "linear-gradient(135deg, #fefefe 0%, #f3f4f7 100%)",
                                boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                                transition: "all 0.3s ease-in-out",
                                "&:hover": {
                                    transform: "scale(1.02)",
                                },
                            }}>
                                <Grid container spacing={3}>
                                    {/* Signature */}
                                    <Grid item xs={12} md={6}>
                                        <Typography fontWeight="bold">✍️ Signature:</Typography>
                                        {getTransactionsById?.user_id?.signature_image ? (
                                            <img
                                                src={getTransactionsById?.user_id?.signature_image}
                                                alt="Signature"
                                                style={{ width: 200, marginTop: 8, borderRadius: 8 }}
                                            />
                                        ) : (
                                            <Typography color="text.secondary">No data inserted</Typography>
                                        )}
                                    </Grid>
                        
                                    {/* Profile Image */}
                                    <Grid item xs={12} md={6}>
                                        <Typography fontWeight="bold">🧑 Profile Image:</Typography>
                                        {getTransactionsById?.user_id?.profile_image ? (
                                            <img
                                                src={getTransactionsById?.user_id?.profile_image}
                                                alt="Profile"
                                                style={{ width: 200, marginTop: 8, borderRadius: 8 }}
                                            />
                                        ) : (
                                            <Typography color="text.secondary">No data inserted</Typography>
                                        )}
                                    </Grid>
                        
                                    {/* Personal Info */}
                                    {[
                                        { label: '👤 Name', value: getTransactionsById?.user_id?.name },
                                        { label: '📧 Email', value: getTransactionsById?.user_id?.email },
                                        { label: '📞 Phone', value: getTransactionsById?.user_id?.phone },
                                        { label: '⚧ Gender', value: getTransactionsById?.user_id?.gender },
                                        { label: '🎂 DOB', value: getTransactionsById?.user_id?.dob ? new Date(getTransactionsById?.user_id?.dob).toLocaleDateString() : null },
                                        { label: '🩸 Blood Group', value: getTransactionsById?.user_id?.blood_group },
                                        { label: '🌍 Nationality', value: getTransactionsById?.user_id?.nationality }
                                    ].map((item, idx) => (
                                        <Grid item xs={12} md={6} key={idx}>
                                            <Typography><strong>{item.label}:</strong> {item.value || <span style={{ color: "gray" }}>No data inserted</span>}</Typography>
                                        </Grid>
                                    ))}
                        
                                    {/* Permanent Address */}
                                    <Grid item xs={12}>
                                        <Typography fontWeight="bold" sx={{ mt: 2 }}>🏠 Permanent Address:</Typography>
                                        {getTransactionsById?.user_id?.address?.permanent?.street ? (
                                            <Typography>
                                                {getTransactionsById?.user_id?.address?.permanent?.street},{" "}
                                                {getTransactionsById?.user_id?.address?.permanent?.city},{" "}
                                                {getTransactionsById?.user_id?.address?.permanent?.state} -{" "}
                                                {getTransactionsById?.user_id?.address?.permanent?.pincode}
                                            </Typography>
                                        ) : (
                                            <Typography color="text.secondary">No data inserted</Typography>
                                        )}
                                    </Grid>
                        
                                    {/* Correspondence Address */}
                                    <Grid item xs={12}>
                                        <Typography fontWeight="bold" sx={{ mt: 2 }}>📬 Correspondence Address:</Typography>
                                        {getTransactionsById?.user_id?.address?.correspondence?.street ? (
                                            <Typography>
                                                {getTransactionsById?.user_id?.address?.correspondence?.street},{" "}
                                                {getTransactionsById?.user_id?.address?.correspondence?.city},{" "}
                                                {getTransactionsById?.user_id?.address?.correspondence?.state} -{" "}
                                                {getTransactionsById?.user_id?.address?.correspondence?.pincode}
                                            </Typography>
                                        ) : (
                                            <Typography color="text.secondary">No data inserted</Typography>
                                        )}
                                    </Grid>
                        
                                    {/* Aadhaar */}
                                    <Grid item xs={12} md={6}>
                                        <Typography fontWeight="bold" sx={{ mt: 2 }}>🆔 Aadhaar Number:</Typography>
                                        <Typography>{getTransactionsById?.user_id?.aadhaar_number || <span style={{ color: "gray" }}>No data inserted</span>}</Typography>
                                        {getTransactionsById?.user_id?.aadhaar_image ? (
                                            <img
                                                src={getTransactionsById?.user_id?.aadhaar_image}
                                                alt="Aadhaar"
                                                style={{ width: 200, marginTop: 8, borderRadius: 8 }}
                                            />
                                        ) : (
                                            <Typography color="text.secondary" sx={{ mt: 1 }}>No Aadhaar image inserted</Typography>
                                        )}
                                    </Grid>
                        
                                    {/* PAN */}
                                    <Grid item xs={12} md={6}>
                                        <Typography fontWeight="bold" sx={{ mt: 2 }}>💳 PAN Number:</Typography>
                                        <Typography>{getTransactionsById?.user_id?.pan_number || <span style={{ color: "gray" }}>No data inserted</span>}</Typography>
                                        {getTransactionsById?.user_id?.pan_image ? (
                                            <img
                                                src={getTransactionsById?.user_id?.pan_image}
                                                alt="PAN"
                                                style={{ width: 200, marginTop: 8, borderRadius: 8 }}
                                            />
                                        ) : (
                                            <Typography color="text.secondary" sx={{ mt: 1 }}>No PAN image inserted</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Box>

                        )}

                        {/* Course Details */}
                        {tabIndex === 1 && (
                            <Box>

                                <Paper elevation={4} sx={{
                                    p: 4,
                                    borderRadius: 4,
                                    background: "linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)",
                                    boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
                                    transition: "all 0.3s ease-in-out",
                                    "&:hover": {
                                        transform: "scale(1.02)",
                                    },
                                }}>
                                    <Box display="flex" flexDirection="column" gap={2}>
                                        <Typography variant="h6" color="text.secondary">
                                            <strong>🎓 Title:</strong> <span style={{ color: "#333" }}>{getTransactionsById?.course_id?.title}</span>
                                        </Typography>

                                        <Divider />

                                        <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
                                            <strong>📝 Description:</strong><br />
                                            <span style={{ color: "#555" }}>{getTransactionsById?.course_id?.description}</span>
                                        </Typography>

                                        <Divider />

                                        <Typography variant="body1">
                                            <strong>💸 Price:</strong> <span style={{ color: "#4CAF50", fontWeight: 600 }}>₹{getTransactionsById?.course_id?.price}</span>
                                        </Typography>

                                        <Divider />

                                        <Typography variant="body1">
                                            <strong>⏱ Duration:</strong> <span style={{ color: "#1976d2", fontWeight: 500 }}>{getTransactionsById?.course_id?.duration}</span>
                                        </Typography>

                                        <Divider />

                                        <Typography variant="body1">
                                            <strong>📅 Enrolled At:</strong> <span style={{ color: "#333" }}>{new Date(getTransactionsById?.enrolled_at).toLocaleString()}</span>
                                        </Typography>

                                        <Typography variant="body1">
                                            <strong>⏳ Expiry Date:</strong> <span style={{ color: "#d32f2f", fontWeight: 500 }}>{new Date(getTransactionsById?.expiry_date).toLocaleDateString()}</span>
                                        </Typography>
                                    </Box>
                                </Paper>
                            </Box>
                        )}
                    </>
                )}

            </Box>
        </Dialog>
    );
};

export default TransactionsDetailsDialog;
